import type { DialogPassThroughOptions, DialogProps } from 'primevue/dialog'

/**
 * Props interface for the TwnDialog component.
 * Extends PrimeVue DialogProps with Twine-specific defaults.
 */
export interface TwnDialogProps extends /* @vue-ignore */ Omit<DialogProps, 'pt'> {
  /**
   * Controls dialog visibility
   */
  visible?: boolean
  /**
   * The header text or title of the dialog
   */
  header?: string
  /**
   * Whether the dialog is modal (blocks interaction with background)
   */
  modal?: boolean
  /**
   * Whether to show a close button in the header
   */
  closable?: boolean
  /**
   * Whether the dialog can be dragged
   */
  draggable?: boolean
  /**
   * Whether the dialog should be dismissable by clicking outside
   */
  dismissableMask?: boolean
  /**
   * Whether Escape closes the dialog. It closes only when nothing sits above it.
   */
  closeOnEscape?: boolean
  /**
   * Custom styling for the dialog
   */
  style?: Record<string, string | number> | string
  /**
   * Pass-through options for customizing internal elements
   */
  pt?: DialogPassThroughOptions
}

/**
 * Default props for the TwnDialog component.
 * Provides sensible defaults for optional properties.
 */
export const DEFAULT_TWN_DIALOG_PROPS = {
  modal: true,
  closable: true,
  draggable: false,
  dismissableMask: true,
  closeOnEscape: true
} as const
